<template>
  <!-- 此頁為點擊 APP 鈴鐺出現的通知頁面 -->
  <div class="notice-div scroll-div" @scroll="scrollEvent">
    <!-- top -->
    <div class="notice-top">
      <div class="notice-title">通知</div>
      <div v-if="getNotificationAllData.length > 0" class="read-all-btn" @click="readAll()">全部標為已讀</div>
    </div>
    <!-- 通知列表 -->
    <div :class="[isReadAll ? 'read-all' : '', 'notice-list']">
      <div v-for="item in getNotificationAllData" @click="readThisNotify(item.PostId, item.NotificationId)" :key="item.NotificationId" :class="[item.Read ? 'readed' : '', 'notice-item']">
        <router-link :to="{ name: 'OnePost', params: { postId: item.PostId, notificationId: item.NotificationId } }">
          <img class="notice-avatar-img" :src="item.MemObj.AvatarImg" />
          <div class="list-item-right">
            <div class="item-info overflow-ellipsis-2">{{ item.MemObj.NickName }} {{ interactionType(item.Type, item.Content) }}</div>
            <div class="item-time">{{ postTime(item.Time.num, item.Time.unit) }}</div>
          </div>
        </router-link>
      </div>
    </div>
    <!-- 無通知時的提醒文字 -->
    <h6 v-if="getNoticeLoadStatus && getNotificationAllData.length === 0" class="no-post">這裡沒有任何通知</h6>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
export default {
  name: 'NoticeMessage',
  data() {
    return {
      isReadAll: false
    };
  },
  created() {
    // 防止進入單篇文章後按上一頁回到此頁又再 load 新資料
    if (this.nextPage === 0) {
      this.getApiNotificationData();
      this.updateNotifyLastActivityTime();
    }
  },
  computed: {
    ...mapState('NoticeMessageModule', ['nextPage']),
    ...mapGetters('NoticeMessageModule', ['getNotificationAllData', 'getNoticeLoadStatus', 'getIsLastPage'])
  },
  methods: {
    ...mapActions('NoticeMessageModule', ['getApiNotificationData', 'updateNotifyLastActivityTime', 'readAllNotification', 'readOnePost']),
    ...mapMutations('NoticeMessageModule', ['READ_ALL_NOTIFY']),
    // 滾輪事件 需搭配 css 'scroll-div'
    scrollEvent(e) {
      if (e.srcElement.scrollTop + e.srcElement.offsetHeight > e.srcElement.scrollHeight - 50) {
        // 前次 API loading 狀態 load 完了且還有下一頁可以 Load 時觸發
        if (this.getNoticeLoadStatus && !this.getIsLastPage) {
          // 載入下一頁貼文牆貼文資料
          this.getApiNotificationData();
        }
      }
    },
    // type 通知內容, 1:動態按讚 2:動態回復 3:動態分享 4:動態標記 5:留言按讚 6:留言回覆
    interactionType(type, content) {
      let interactionWord = '';
      if (content.indexOf('https://mtx.lale.im:8443/_matrix/media/r0/download/lalepass.lale.im') > -1) {
        content = '一張貼圖';
      } else {
        content = `:「${content}」`;
      }
      switch (type) {
        case '1':
          interactionWord = '對你的動態按讚';
          break;
        case '2':
          interactionWord = '回覆了你的動態' + content;
          break;
        case '3':
          interactionWord = '分享你的動態'; // 後端無傳此值，待確認後端是否有實作此段
          break;
        case '4':
          interactionWord = '將你標記在動態中'; // 後端無傳此值，待確認後端是否有實作此段
          break;
        case '5':
          interactionWord = '對你的留言按讚';
          break;
        case '6':
          interactionWord = '回覆了你' + content;
          break;
      }
      return interactionWord;
    },
    // 發文時間單位整理 TODO:抽出成共用
    postTime(num, unit) {
      if (unit === 'date') {
        return num;
      } else if (unit === 'hour') {
        return num + '小時前';
      } else if (unit === 'minute') {
        return num + '分鐘前';
      }
    },
    // 已讀全部
    readAll() {
      this.isReadAll = true;
      this.readAllNotification();
      this.READ_ALL_NOTIFY();
    },
    // 已讀單篇通知
    readThisNotify(postId, notificationId) {
      this.readOnePost({ postId, notificationId });
    }
  }
};
</script>

<style lang="scss" scoped>
.notice-div {
  .no-post {
    text-align: center;
    margin-top: 250px;
    color: $LaleGray8;
  }
}

.scroll-div {
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
}

.notice-top {
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  margin: 15px;
  .notice-title {
    display: flex;
    color: $LaleGray8;
  }

  .read-all-btn {
    display: flex;
    color: $LalePrimary;
  }
}

.read-all .notice-item {
  background-color: #ffffff;
  border-bottom: 1px solid #e8e8e8;
}

.notice-item {
  display: flex;
  background-color: $LaleLightPrimary;
  border-bottom: 1px solid #ffffff;
  a {
    padding: 15px;
    display: flex;
    width: 100%;
  }

  &.readed {
    background-color: #ffffff;
    border-bottom: 1px solid #e8e8e8;
  }

  .list-item-right {
    display: flex;
    width: calc(100% - 60px);
    flex-flow: column;
    justify-content: center;
    color: $LaleTitleBlack;

    // .item-info {
    //   display: flex;
    // }
  }

  .notice-avatar-img {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    display: inline-block;
    margin-right: 10px;
  }
}
</style>
